import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Autocomplete, Button } from '@totalsoft/rocket-ui';
import FolderAllocateResponsibleListItem from './FolderAllocateResponsibleListItem';
import { CheckCircle, CheckCircleOutline, AssignmentInd } from '@mui/icons-material';
import WrappedFakeText from 'components/common/WrappedFakeText';

const FolderAllocateResponsibleList = ({
  t,
  responsibleId,
  responsibleChangeFolders,
  loadResponsibles,
  handleResponsibleChange,
  handleResponsibleSave,
  handleAllocateFolders,
  handleSelectAllFolders,
  handleDeselectAll,
  selectedFolderList,
  loading,
  saving
}) => {
  const onAllocateFolders = (folder, checked) => {
    handleAllocateFolders(folder, checked);
  };

  return (
    <>
      <Grid container justifyContent='space-between' alignItems='center'>
        <Grid item flexGrow={1} maxWidth='500px'>
          <Autocomplete
            id={'folderAllocateResponsible_responsible'}
            fullWidth
            name='folderResponsible'
            value={responsibleId || null}
            valueKey='responsibleId'
            labelKey='name'
            label={t('FolderAllocateResponsible.Responsible')}
            loadOptions={loadResponsibles}
            onChange={handleResponsibleChange}
            disabled={false}
            isClearable={true}
          />
        </Grid>
        <Grid item display='flex' gap={1}>
          <Button id={'folderAllocateResponsible_selectAllBtn'} startIcon={<CheckCircle />} onClick={handleSelectAllFolders}>
            {t('FolderAllocateResponsible.SelectAll')}
          </Button>
          <Button
            id={'folderAllocateResponsible_deselectAllBtn'}
            startIcon={<CheckCircleOutline />}
            onClick={handleDeselectAll}
            disabled={selectedFolderList.length === 0}
          >
            {t('FolderAllocateResponsible.DeselectAll')}
          </Button>
          <Button
            id={'folderAllocateResponsible_saveBtn'}
            startIcon={<AssignmentInd />}
            onClick={handleResponsibleSave}
            disabled={responsibleId && selectedFolderList.length > 0 && !saving ? false : true}
          >
            {saving ? t('FolderAllocateResponsible.Allocating') : t('FolderAllocateResponsible.Allocate')}
          </Button>
        </Grid>
      </Grid>
      <Grid my={2} flexDirection='column' display='flex' gap={1}>
        {loading ? (
          <WrappedFakeText />
        ) : (
          responsibleChangeFolders.length > 0 &&
          responsibleChangeFolders.map((folder, idx) => {
            return (
              <FolderAllocateResponsibleListItem
                key={idx}
                item={folder}
                onAllocateFolders={onAllocateFolders}
                selectedFolderList={selectedFolderList}
              />
            );
          })
        )}
      </Grid>
    </>
  );
};

FolderAllocateResponsibleList.propTypes = {
  t: PropTypes.func.isRequired,
  responsibleChangeFolders: PropTypes.array.isRequired,
  loadResponsibles: PropTypes.func.isRequired,
  handleResponsibleChange: PropTypes.func.isRequired,
  handleResponsibleSave: PropTypes.func.isRequired,
  handleAllocateFolders: PropTypes.func.isRequired,
  handleSelectAllFolders: PropTypes.func.isRequired,
  handleDeselectAll: PropTypes.func.isRequired,
  selectedFolderList: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  responsibleId: PropTypes.number
};

export default withTranslation()(FolderAllocateResponsibleList);
